<div class="jump-links">
  @for (jumpLink of jumpLinks; track jumpLink) {
    <ds-jump-link [jumpLink]="jumpLink" [size]="size"></ds-jump-link>
  }
</div>
